export default "__VITE_ASSET__1z_cQuKQ__"